import { createFileRoute, Navigate } from '@tanstack/react-router';

const Component = () => {
  const { familyId } = Route.useParams();
  return (
    <Navigate
      to='/families/$familyId/summary'
      params={{ familyId }}
      replace
    />
  );
};

export const Route = createFileRoute('/_auth/_layout/families/$familyId/')({
  component: Component,
});
